$(document).ready(function () {
    setTimeout(function() {
         $("#submitRFQForm").on('click', function(event){
				if($("#submitRFQForm").hasClass("disabled") == false){
                  
					/*Perform all actions here..*/
					
					var productTable = $(".grfq-product-table").html();                  
					var firstName = $("#first-name").val();
					var lastName = $("#last-name").val();
					var email = $("#email").val();
					var phone = $("input[type=tel]").val();
					var address = $("#address").val();
					var suburb = $("#suburb").val();
					var state = $("#state").val();
					var postcode = $("#postcode").val();
					var country = $("#country").val();
					var message = $("#message").val();
                    var supply_install = $("input[name='supply-install']:checked").val();

					var preferredStore = $("#select-1654850244298").val();
					
					var formData = {
					  productTable: productTable,
					  firstName: firstName,
					  lastName: lastName,
					  email: email,
					  phone: phone,
					  address: address,
					  suburb: suburb,
					  state: state,
					  postcode: postcode,
					  country: country,
					  message: message,
                      supply_install : supply_install,
					  preferredStore: preferredStore,
					};               
					
					$.ajax({
					  type: "POST",
					  url: "https://media365.com.au/tileboutique/index-tbnew.php",
					  data: formData,
					  dataType: "json",
					  encode: true,
					}).done(function (data) {
					  console.log(data);
					});
					
				}else{
					console.log("Class exist.. wait!!");
				}	
           //event.preventDefault();
		  });
	}, 5000);      
});	
